"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_native_1 = require("react-native");
const styles = react_native_1.StyleSheet.create({
    input: {
        height: 100,
        minWidth: 350,
    },
});
exports.default = styles;
